import {all, call, fork, put, takeEvery} from 'redux-saga/effects';
import {
    MAIN_LAYOUT, MAIN_LAYOUT_CHECK
} from './constants';
import {
    layoutMainSignCheck,
    layoutMainFail, layoutMainNotChooseCorp, layoutMainNotSignIn,
    layoutMainSuccess, layoutMainNoPermission
} from './actions';
import {fetchJSON} from "../../../../helpers/FetchUtils";
import {catchError, showErrorToast} from "../../../../util/ErrorCatchUtils";
import {commonToast} from "../../toast/actions";
import {isEmpty} from "../../../../helpers/EmptyUtils";

//
function* layoutMain({payload: {params}}) {
    try {
        let {url} = params;
        if(!url) {
            yield put(layoutMainSuccess({params}));
            return;
        }
        const response = yield call(fetchJSON,
            url,
            {method: 'GET'});
        if (response.success) {
            let responseData = response.data;
            let loadDatas = {...responseData};
            params = {...params, ...loadDatas};
            yield put(layoutMainSuccess({loadDatas, params}));
        } else {
            yield put(layoutMainSignCheck({...response, showToast: false}));
            if (response.errorCode === 10504) {
                yield put(layoutMainNoPermission());
            }
            yield put(layoutMainFail(response));
        }
    } catch (error) {
        yield put(layoutMainSignCheck(showErrorToast(error)));
        yield put(layoutMainFail(catchError(error)));
    }
}

//
function* layoutMainSignCheckAction({payload: {errors, errorCode, message, showToast}}) {
    if (errorCode === 10501) {
        yield put(layoutMainNotSignIn());
    } else if (errorCode === 10505) {
        yield put(layoutMainNotChooseCorp());
    } else {
        let errorMessage = '';
        if (errors && errors.errorMessage) {
            errorMessage = errors.errorMessage;
        } else {
            if (!isEmpty(message)) {
                errorMessage = message;
            }
        }
        if (showToast === true && !isEmpty(errorMessage)) {
            yield put(commonToast({errorMessage, errorCode}));
        }
    }
}

//
export function* layoutMainWatcher() {
    yield takeEvery(MAIN_LAYOUT, layoutMain);
}

//
export function* layoutMainSignCheckActionWatcher() {
    yield takeEvery(MAIN_LAYOUT_CHECK, layoutMainSignCheckAction);
}

//
function* LayoutMainSaga() {
    yield all([
        fork(layoutMainWatcher),
        fork(layoutMainSignCheckActionWatcher)]);
}

//
export default LayoutMainSaga;
